<template>
  <div>
    <h3>Lägg till virtuell enhet</h3>
    <p>En virtuell enhet är en enhet i din Bridge som inte skickar ut några radiosignaler, du kan använda denna enheten som ex. villkor i automationer eller aktivera ett larm med.</p>
    
    <div class="form">
      <div class="item">
        <input type="text" placeholder="Namn på enheten" v-model="name">
      </div>
      <div class="item" v-if="rooms.length">
        <div class="label">Rum</div>
        <select v-model="room">
          <option value="0" disabled>Välj ett rum...</option>
          <option v-for="room in rooms" :value="room.id">{{ room.name }}</option>
        </select>
        <div class="descr">Du kan välja att placera din nya enhet i ett rum redan här.</div>
      </div>
      <p>
        <button :disabled="!ok" @click="save">{{ saving ? 'Sparar...' : 'Spara enheten' }}</button>
      </p>
    </div>
  </div>
</template>

<script>
  import { HTTP } from '../http.js'

  export default {
    name: 'HelloWorld',
    data () {
      return {
        name: '',
        room: 0,
        saving: false
      }
    },
    created () { },
    methods: {
      save () {
        this.saving = true
        
        HTTP.post('nodes', {
          name: this.name,
          roomId: this.room,
          type: 'Dummy',
          capabilities: [
            'switchBinary'
          ]
        })
        .then(res => res.data)
        .then(json => {
          // Enheten lades till
          if (json.status === 'OK') {
            // Hämta den nya enheten så vi kan spara den
            // i vår globala array
            HTTP.get('nodes/' + json.id)
            .then(res => res.data)
            .then(jsonNode => {
              // Pusha in enheten i listan
              this.$root.data.nodes.push(jsonNode)
              
              // Skicka vidare användaren
              this.$router.push({
                name: 'enhet',
                params: {
                  id: json.id
                }
              })
            })
          }
        })
      }
    },
    computed: {
      ok () {
        return this.name.length && !this.saving
      },

      rooms () {
        return this.$root.data.rooms.filter(room => room.id > 0)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/add_virtuell.vue